import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_POLICY = "identity-service/access-management/policies";

const RESOURCES = {
	PAGINATED_POLICYS: (page, searchText, clientId, orderBy) =>
		`${BASE_POLICY}/paginated?page=${page}&limit=8` +
		`&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}`,
	LIST_POLICYS: () => `${BASE_POLICY}`,
	GET_POLICY: (id) => `${BASE_POLICY}/${id}`,
	CREATE_POLICY: () => `${BASE_POLICY}`,
	UPDATE_POLICY: (id) => `${BASE_POLICY}/${id}`,
	DELETE_POLICY: (id) => `${BASE_POLICY}/${id}`,
};

class PolicyService {
	static async getPaginated(page, searchText, clientId, orderBy) {
		try {
			return await axios.get(
				RESOURCES.PAGINATED_POLICYS(page, searchText, clientId, orderBy),
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao listar políticas de acesso paginadas",
			});
			return error.response;
		}
	}

	static async listPolicies() {
		try {
			return await axios.get(RESOURCES.LIST_POLICYS());
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao listar políticas de acesso",
			});
			return error.response;
		}
	}

	static async getPolicy(id) {
		try {
			return await axios.get(RESOURCES.GET_POLICY(id));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao buscar política de acesso",
			});
			return error.response;
		}
	}

	static async createPolicy(payload) {
		try {
			const response = await axios.post(RESOURCES.CREATE_POLICY(), payload);
			ResponseAlerts({
				response,
				successMessage: "Política de acesso criada com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao criar política de acesso",
			});
			return error.response;
		}
	}

	static async updatePolicy(id, payload) {
		try {
			const response = await axios.put(RESOURCES.UPDATE_POLICY(id), payload);
			ResponseAlerts({
				response,
				successMessage: "Política de acesso atualizada com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao atualizar política de acesso",
			});
			return error.response;
		}
	}

	static async deletePolicy(id) {
		try {
			const response = await axios.delete(RESOURCES.DELETE_POLICY(id));
			ResponseAlerts({
				response,
				successMessage: "Política de acesso removida com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao remover política de acesso",
			});
			return error.response;
		}
	}
}

export default PolicyService;
